import Typography from "@material-ui/core/Typography";
import { observer } from "mobx-react-lite";
import { webStore } from "../stores/webStore";

import {
  Box,
  Grid,
  CardActionArea,
  Paper,
  Container,
} from "@material-ui/core";
import React from "react";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
export const ProjectWrapper = observer(({ children }: any) => {
  if (!webStore.selectedProject) {
    return (
      <Box m={5}>
        <Container maxWidth="sm">
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <Typography component={'span'} variant="subtitle1">กรุณา เลือก Project</Typography>
            </Grid>
            {(webStore.profile?.project || []).map((project, i) => {
              const { name_th } = project;
              return (
                <Grid item key={i}>
                  <CardActionArea
                    onClick={() => {
                      webStore.setSelectedProject(project);
                    }}
                  >
                    <Paper>
                      <Box p={6} fontSize="large" fontWeight="bold">
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          justify="space-between"
                          spacing={3}
                        >
                          <div>{name_th}</div>
                          <ChevronRightIcon />
                        </Grid>
                      </Box>
                    </Paper>
                  </CardActionArea>
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </Box>
    );
  }

  return <>{children}</>;
});
